// config.js
export const apiUrl = 'https://itesseract.com.bd/main';
